import { colors } from '@/lib/analytics/colors';
import { SIZE_33 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const totalSharesConfig = {
    name: 'kpi.tiktok.total_shares',
    id: 'shares',
    icon: {
        name: 'share',
        style: colors.aquablue
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    tooltip: 'kpi.linkedin.tooltip_total_shares',
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_33,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    mergedData: true,
    element: KPIDefault,
    loader: DefaultLoader,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
